import { format } from '@formkit/tempo';
const FORMAT_DATE = 'YYYY-MM-DD';
// Збирає URL search page: базова частина (мова, місто) + дати й гості з форми
const generateSearchPageUrl = ({ baseUrl, formData, }) => {
    const { checkIn, checkOut, adultsCount, children } = formData;
    const url = new URL(baseUrl, window.location.origin);
    url.searchParams.set('check_in', format(checkIn, FORMAT_DATE));
    url.searchParams.set('check_out', format(checkOut, FORMAT_DATE));
    url.searchParams.set('adults', String(adultsCount));
    children
        .filter(Boolean)
        .forEach(({ age }) => url.searchParams.append('childrens[]', String(age)));
    return url.toString();
};
export default generateSearchPageUrl;
